import { render, staticRenderFns } from "./uploadWXImg.vue?vue&type=template&id=266603c8&scoped=true&"
import script from "./uploadWXImg.vue?vue&type=script&lang=js&"
export * from "./uploadWXImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadWXImg.vue?vue&type=style&index=0&id=266603c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266603c8",
  null
  
)

export default component.exports